(function () {
  "use strict";

  const ONURA_MASK_VARIANT_ID = 58282348839293;

  const ONURA_KIT_VARIANT_IDS = [
    58175838388605, // S
    58175838421373, // M
    58175838454141, // L
    58175838486909  // XL
  ];

  const MASK_LINE_CLASS = "onura-mask-line-hidden";

  let isSyncing = false;
  let needsAnotherSync = false;
  let syncTimeout = null;

  async function fetchCart() {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Unable to fetch cart.");
    }

    return response.json();
  }

  async function addMask(quantity) {
    if (quantity <= 0) return;

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: ONURA_MASK_VARIANT_ID,
        quantity: quantity,
        properties: {
          "_onura_technical_item": "mask",
          "_onura_linked_to": "arari-box-01"
        }
      })
    });

    if (!response.ok) {
      throw new Error("Unable to add mask.");
    }

    return response.json();
  }

  async function changeLineQuantity(lineKey, quantity) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error("Unable to change cart line.");
    }

    return response.json();
  }

  function getKitQuantity(cart) {
    return cart.items.reduce(function (total, item) {
      if (ONURA_KIT_VARIANT_IDS.includes(Number(item.variant_id))) {
        return total + Number(item.quantity);
      }

      return total;
    }, 0);
  }

  function getMaskLines(cart) {
    return cart.items.filter(function (item) {
      return Number(item.variant_id) === ONURA_MASK_VARIANT_ID;
    });
  }

  function getMaskQuantity(maskLines) {
    return maskLines.reduce(function (total, item) {
      return total + Number(item.quantity);
    }, 0);
  }

  async function syncMaskWithKit() {
    if (isSyncing) {
      needsAnotherSync = true;
      return;
    }

    isSyncing = true;
    needsAnotherSync = false;

    try {
      const cart = await fetchCart();

      const kitQuantity = getKitQuantity(cart);
      const maskLines = getMaskLines(cart);
      const maskQuantity = getMaskQuantity(maskLines);
      const mainMaskLine = maskLines[0];

      console.log("[ONURA] kitQuantity:", kitQuantity, "maskQuantity:", maskQuantity);

      if (kitQuantity === 0) {
        for (const maskLine of maskLines) {
          await changeLineQuantity(maskLine.key, 0);
        }

        refreshCartUI();
        return;
      }

      if (!mainMaskLine && kitQuantity > 0) {
        await addMask(kitQuantity);
        refreshCartUI();
        return;
      }

      if (mainMaskLine && maskQuantity !== kitQuantity) {
        await changeLineQuantity(mainMaskLine.key, kitQuantity);

        if (maskLines.length > 1) {
          for (let i = 1; i < maskLines.length; i++) {
            await changeLineQuantity(maskLines[i].key, 0);
          }
        }

        refreshCartUI();
        return;
      }

      hideMaskLines();
    } catch (error) {
      console.warn("[ONURA] Mask sync error:", error);
    } finally {
      isSyncing = false;

      if (needsAnotherSync) {
        needsAnotherSync = false;
        scheduleSync(300);
      }

      hideMaskLines();
    }
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimeout);

    syncTimeout = setTimeout(function () {
      syncMaskWithKit();
    }, delay || 600);
  }

  function scheduleMultipleSyncs() {
    scheduleSync(300);

    setTimeout(function () {
      syncMaskWithKit();
    }, 900);

    setTimeout(function () {
      syncMaskWithKit();
    }, 1800);

    setTimeout(function () {
      syncMaskWithKit();
    }, 3000);
  }

  function hideMaskLines() {
    const selectors = [
      '[href*="/products/papa-mask-onura"]',
      '[data-product-handle="papa-mask-onura"]',
      '[data-handle="papa-mask-onura"]',
      '[data-variant-id="' + ONURA_MASK_VARIANT_ID + '"]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        const cartLine = element.closest(
          ".cart-item, .cart-drawer__item, .cart__item, .ajaxcart__product, .drawer__cart-item, .cart-line, li, tr"
        );

        if (cartLine) {
          cartLine.classList.add(MASK_LINE_CLASS);
        }
      });
    });
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("onura:cart:updated"));

    setTimeout(hideMaskLines, 200);
    setTimeout(hideMaskLines, 700);
    setTimeout(hideMaskLines, 1500);
  }

  function isCartRequest(url) {
    if (!url) return false;

    const urlString = String(url);

    return (
      urlString.includes("/cart/add") ||
      urlString.includes("/cart/change") ||
      urlString.includes("/cart/update") ||
      urlString.includes("/cart/clear")
    );
  }

  const originalFetch = window.fetch;

  window.fetch = async function () {
    const requestUrl = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    const isCartAjaxRequest = isCartRequest(requestUrl);

    const response = await originalFetch.apply(this, arguments);

    if (isCartAjaxRequest) {
      scheduleMultipleSyncs();
    }

    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._onuraCartRequest = isCartRequest(url);
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this._onuraCartRequest) {
      this.addEventListener("loadend", function () {
        scheduleMultipleSyncs();
      });
    }

    return originalXHRSend.apply(this, arguments);
  };

async function waitForSyncedCart(maxAttempts) {
  const attempts = maxAttempts || 8;

  for (let i = 0; i < attempts; i++) {
    await syncMaskWithKit();

    const cart = await fetchCart();
    const kitQuantity = getKitQuantity(cart);
    const maskQuantity = getMaskQuantity(getMaskLines(cart));

    console.log("[ONURA] checkout check:", {
      kitQuantity: kitQuantity,
      maskQuantity: maskQuantity,
      attempt: i + 1
    });

    if (kitQuantity === maskQuantity) {
      return true;
    }

    await new Promise(function (resolve) {
      setTimeout(resolve, 400);
    });
  }

  return false;
}

async function syncBeforeCheckout(event) {
  const checkoutTarget = event.target.closest(
    'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"], form[action="/checkout"], form[action*="/checkout"]'
  );

  if (!checkoutTarget) return;

  event.preventDefault();
  event.stopPropagation();

  try {
    await waitForSyncedCart(8);
  } catch (error) {
    console.warn("[ONURA] Checkout sync error:", error);
  }

  window.location.assign("/checkout");
}

  document.addEventListener("DOMContentLoaded", function () {
    scheduleMultipleSyncs();
    hideMaskLines();
  });

  window.addEventListener("pageshow", function () {
    scheduleMultipleSyncs();
    hideMaskLines();
  });

  window.addEventListener("focus", function () {
    scheduleMultipleSyncs();
    hideMaskLines();
  });

  document.addEventListener("click", function (event) {
    syncBeforeCheckout(event);

    const target = event.target;

    if (!target) return;

    if (
      target.closest('form[action*="/cart/add"]') ||
      target.closest('button[name="add"]') ||
      target.closest('button[type="submit"]') ||
      target.closest(".quantity") ||
      target.closest('[href*="/cart/change"]') ||
      target.closest('[data-cart-remove]') ||
      target.closest('[data-cart-quantity]') ||
      target.closest('[name="plus"]') ||
      target.closest('[name="minus"]') ||
      target.closest(".quantity__button") ||
      target.closest(".cart-remove-button")
    ) {
      scheduleMultipleSyncs();
    }
  }, true);

  document.addEventListener("change", function (event) {
    const target = event.target;

    if (!target) return;

    if (
      target.matches('input[name="quantity"]') ||
      target.matches('input[type="number"]') ||
      target.closest(".quantity")
    ) {
      scheduleMultipleSyncs();
    }
  }, true);

  document.addEventListener("cart:updated", scheduleMultipleSyncs);
  document.addEventListener("cart:refresh", hideMaskLines);
  document.addEventListener("ajaxProduct:added", scheduleMultipleSyncs);

  document.addEventListener("submit", async function (event) {
  const form = event.target;

  if (!form) return;

  if (
    form.matches('form[action="/checkout"]') ||
    form.matches('form[action*="/checkout"]') ||
    form.querySelector('button[name="checkout"], input[name="checkout"]')
  ) {
    event.preventDefault();
    event.stopPropagation();

    try {
      await waitForSyncedCart(8);
    } catch (error) {
      console.warn("[ONURA] Checkout submit sync error:", error);
    }

    window.location.assign("/checkout");
  }
}, true);

  const observer = new MutationObserver(function () {
    hideMaskLines();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();